import { useParams } from "react-router-dom";
import { MissionDetail } from "@/components/missions/MissionDetail";

export const meta = () => [
  { title: "Mission | Ani Tech" },
  { name: "description", content: "Mission details" },
];

interface MissionRouteProps {
  /** OS-mode injects this directly; classic mode relies on URL params. */
  missionId?: string;
}

function MissionView({ missionId: propMissionId }: MissionRouteProps) {
  const { id } = useParams<{ id: string }>();
  const missionId = propMissionId ?? id;
  if (!missionId) return null;
  return <MissionDetail missionId={missionId} />;
}

export default function MissionRoute() {
  return <MissionView />;
}

/** Named export consumed by OS-mode window registry. */
export { MissionView as MissionDetailRoute };
